import React from 'react';
import {
  SIMPLE_INOUT_QUICK_STATUS_OPTIONS,
  formatSimpleInOutEpochShort,
  simpleInOutLookupMessage,
  useMySimpleInOutStatus,
} from './useMySimpleInOutStatus';
import { openSimpleInOutDotboard, openSimpleInOutStatus } from './simpleInOutEvents';

/**
 * Simple I/O inside the desktop account menu: In/Out/Busy, More (the My status
 * modal), the note and View dotboard. The phone account sheet stays as it is.
 * `onLeave` closes the menu before a modal or drawer opens.
 */
export default function SimpleInOutAccountMenuSection({ onLeave }: { onLeave: () => void }) {
  const sio = useMySimpleInOutStatus();
  if (!sio.visible) return null;

  function openStatus() {
    onLeave();
    openSimpleInOutStatus();
  }

  function openBoard() {
    onLeave();
    openSimpleInOutDotboard();
  }

  return (
    <section className="topbar-account-menu__simple-inout" aria-label="Simple I/O">
      <div className="topbar-account-menu__simple-inout-head">
        <span className="topbar-account-menu__label">Simple I/O</span>
        {sio.loaded ? (
          <span className="topbar-account-menu__simple-inout-stamp">
            Updated {formatSimpleInOutEpochShort(sio.updatedAt)}
          </span>
        ) : null}
      </div>
      {sio.loaded ? (
        <>
          <div className="topbar-account-menu__simple-inout-seg" role="group" aria-label="Set my Simple I/O status">
            {SIMPLE_INOUT_QUICK_STATUS_OPTIONS.map((option) => (
              <button
                key={option.value}
                type="button"
                data-status={option.value}
                aria-pressed={sio.currentStatus === option.value}
                disabled={sio.pending}
                onClick={() => sio.setStatus(option.value)}
              >
                <span className="topbar-account-menu__simple-inout-dot" aria-hidden="true" />
                {option.label}
              </button>
            ))}
            <button type="button" aria-haspopup="dialog" aria-label="More statuses and note" onClick={openStatus}>
              More
            </button>
          </div>
          <div className="topbar-account-menu__simple-inout-note">
            <span>{sio.comment || 'No note'}</span>
            <button type="button" className="topbar-account-menu__simple-inout-edit" aria-haspopup="dialog" onClick={openStatus}>
              {sio.comment ? 'Edit' : 'Add note'}
            </button>
          </div>
        </>
      ) : (
        <p className="topbar-account-menu__simple-inout-message">
          {sio.loading ? 'Loading…' : simpleInOutLookupMessage(sio.payload, sio.error)}
        </p>
      )}
      <button type="button" className="topbar-account-menu__profile-link topbar-account-menu__simple-inout-board" aria-haspopup="dialog" onClick={openBoard}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="4" y="4" width="6" height="6" rx="1" /><rect x="14" y="4" width="6" height="6" rx="1" /><rect x="4" y="14" width="6" height="6" rx="1" /><rect x="14" y="14" width="6" height="6" rx="1" />
        </svg>
        View dotboard
      </button>
    </section>
  );
}
